import React, { createContext, useContext } from 'react';

export interface PricingFormContextValue {
    feeItemDataMap: Map<number, any>;
    updateFeeItemDataByCode: (feeItemCodeNum: number, newData: any) => void;
}

export const PricingFormContext = createContext<PricingFormContextValue | null>(null);

export function usePricingFormContext(): PricingFormContextValue | null {
    return useContext(PricingFormContext);
}
